const ar_common = {
  // Navigation
  "nav.home": "الرئيسية",
  "nav.about": "من نحن",
  "nav.services": "خدماتنا",
  "nav.doctors": "الاستشاريون",
  "nav.packages": "مستويات الرعاية",
  "nav.dna_simulator": "محاكي الحمض النووي",
  "nav.offers": "العروض",
  "nav.blog": "المدونة",
  "nav.faq": "الأسئلة الشائعة",
  "nav.contact": "تواصل معنا",
  "nav.book": "احجز موعدك",
  "nav.search": "ابحث...",
  "nav.lang_switch": "EN",

  // Common buttons
  "btn.book_now": "احجز الآن",
  "btn.learn_more": "اعرف المزيد",
  "btn.view_all": "عرض الكل",
  "btn.back": "السابق",
  "btn.next": "التالي",
  "btn.submit": "إرسال",
  "btn.close": "إغلاق",
  "btn.details": "التفاصيل",
  "btn.contact_us": "تواصل معنا",
  "btn.show_results": "عرض النتائج",
  "btn.retake": "إعادة التقييم",

  // Common labels
  "label.sar": "ريال",
  "label.minutes": "دقيقة",
  "label.years_exp": "سنة خبرة",
  "label.free": "مجاني",
  "label.save": "وفر",
  "label.most_popular": "الأكثر طلباً",
  "label.exclusive": "حصري",
  "label.featured": "مميز",
  "label.new": "جديد",
  "label.available": "متاح",
  "label.loading": "جاري التحميل...",
  "label.no_results": "لا توجد نتائج",

  // Footer
  "footer.tagline": "منصة متقدمة للطب الدقيق والرعاية التخصصية",
  "footer.quick_links": "روابط سريعة",
  "footer.services": "الخدمات",
  "footer.contact_info": "معلومات التواصل",
  "footer.rights": "جميع الحقوق محفوظة",
  "footer.privacy": "سياسة الخصوصية",
  "footer.terms": "الشروط والأحكام",
  "footer.newsletter": "اشترك في نشرتنا",
  "footer.newsletter_desc": "آخر المقالات والعروض الطبية",
  "footer.newsletter_placeholder": "بريدك الإلكتروني",
  "footer.newsletter_btn": "اشتراك",

  // WhatsApp
  "whatsapp.tooltip": "تواصل عبر واتساب",

  // Search
  "search.placeholder": "ابحث عن طبيب، خدمة، باقة...",
  "search.no_results": "لا توجد نتائج لـ",
  "search.advanced": "بحث متقدم",
  "search.doctors": "الأطباء",
  "search.services": "الخدمات",
  "search.packages": "الباقات",
  "search.view_all": "عرض جميع نتائج",

  "days.sun": "الأحد",
  "days.mon": "الاثنين",
  "days.tue": "الثلاثاء",
  "days.wed": "الأربعاء",
  "days.thu": "الخميس",
  "days.fri": "الجمعة",
  "days.sat": "السبت",
  "months.jan": "يناير",
  "months.feb": "فبراير",
  "months.mar": "مارس",
  "months.apr": "أبريل",
  "months.may": "مايو",
  "months.jun": "يونيو",
  "months.jul": "يوليو",
  "months.aug": "أغسطس",
  "months.sep": "سبتمبر",
  "months.oct": "أكتوبر",
  "months.nov": "نوفمبر",
  "months.dec": "ديسمبر",
};

export default ar_common;
